/**
 * Filters an array of tick values to avoid overlapping X-axis labels.
 *
 * The function calculates how many ticks can fit within the available
 * horizontal space and removes excess ticks by keeping every Nth value.
 *
 * @param ticks         Full list of tick values generated by the scale
 * @param innerWidth   Available chart width in pixels
 * @param minPixelWidth Minimum pixel width required per tick label
 */
export const filterTicksByWidth = <T>(ticks: T[], innerWidth: number, minPixelWidth = 90) => {
  const maxTicks = Math.floor(innerWidth / minPixelWidth);

  if (ticks.length <= maxTicks) return ticks;

  const step = Math.ceil(ticks.length / maxTicks);
  return ticks.filter((_, index) => index % step === 0);
};
